module.exports = __webpack_public_path__ + "8829168254dc1f37a109b090f21e221e.svg";